/**
 * Angular imports.
 */
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

/**
 * Angular imports.
 */
@Component({
  selector: 'app-constant-sum',
  templateUrl: './constant-sum.component.html',
  styleUrls: ['./constant-sum.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConstantSumComponent implements OnInit {

  /**
   *
   */
  @Input() values: { name: string; range: number }[] = [];
  @Input() rangeCriteria: number;
  @Input() isDisabled: boolean;

  /**
   *
   */
  public totalPercentage = 0;
  public entries = [];

  /**
   *
   */
  @Output() emitTotalSumAndEntries: EventEmitter<{ total: number; entries: any[] }> = new EventEmitter();

  /**
   *
   */
  ngOnInit(): void {
    this.entries = JSON.parse(JSON.stringify(this.values));
  }

  /**
   *
   */
  calculateTotal(): void {
    const total = this.entries.reduce((sum, entry) => sum + entry.range, 0);
    if (total <= this.rangeCriteria) {
      this.totalPercentage = Math.floor((total / this.rangeCriteria) * 100);
    } else {
      this.entries.forEach((entry) => {
        entry.range = Math.floor((entry.range / total) * this.rangeCriteria);
      });
      this.totalPercentage = 100;
    }
    this.sendTotalSum(this.totalPercentage, this.entries);
  }

  /**
   *
   */
  sendTotalSum(total, entries): void {
    this.emitTotalSumAndEntries.emit({ total, entries });
  }
}
